import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import FloorMapButton from './floor-map-button';
import { adjustMapboxControlPosition, destroyRichMap, initializeRichMap, } from './util';
import { POI_TYPES, sendTrackingEventForMapClick, } from '../../util';
import { useTranslation } from 'react-i18next';
import { useMap } from '../../layout/MapContext';
import DeskHelper from './desk/desk';
import { closeRoomDetailsPopup } from '../room-details-popup';
import { store } from '../../../../../store/store';
import { setRoomDataFromMap, setPOIDataFromMap, setDeskDataFromMap, setRichMapLoading, getRichMapLoaded, setDirections, getCheckIfModelReqFlag, } from '../../../../../store/uislice';
import { WhereAmISwitchFloor } from '../where-am-i-switch-floor';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getLocation, getContext, setSelectedLocation, getSelectedLocation, } from '../../../redux/spaces-slice';
import styled from 'styled-components';
import MapCompass from '../../../../../assets/svgs/map-compass';
import Search from '../../../../../assets/svgs/search';
import { Flex } from '@magnetic/flex';
import { setRoomSearchPopUp } from '../../../../../store/uislice';
const Button = styled.div `
  background: linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%);
  border-radius: 0.6vw;
  min-height: 2.6vw;
  width: 8.48vw;
  padding: 0 0.8vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45vw;
  font-family: 'CiscoSans Thin';
  margin-bottom: 0.34vw;
  min-width: fit-content;
`;
const ButtonIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
const ButtonLabel = styled.div `
  font-size: 1vw;
  line-height: 1;
  white-space: nowrap;
`;
const WhereAmIButton = styled(Button) `
  justify-content: center;
  gap: 0.35vw;
  position: relative;
  overflow: visible;
  min-width: fit-content;
`;
const WhereAmIIcon = styled.img `
  height: 4vw;
  width: auto;
  flex-shrink: 0;
  margin-top: -1.6vw;
`;
const WhereAmILabel = styled(ButtonLabel) `
  font-size: 1vw;
  line-height: 1;
`;
const Button2 = styled(Flex) `
  background: ${(props) => props.background};
  box-shadow: 0px 2px 0px 0px rgba(52, 56, 62, 1) inset;
  border-radius: 0.6vw;
  height: 2.4vw;
  min-width: 4.4vw;
  line-height: 2.6vw;
  padding: 0.2vw 1vw;
  font-size: 0.8vw;
  border: 1px solid rgba(103, 103, 103, 1);
  cursor: pointer;
`;
const Line = styled.div `
  height: 2.6vw;
  width: 0.08vw;
  background: rgba(97, 96, 96, 1);
`;
const THEMES = {
    DARK_WITHOUT_WORLD_MAP: 'dark-wo-world-map.json',
    DARK: 'dark.json',
};
const MapComponent = ({ richMapAccessToken, mapDetails, roomAvailability, deskStatus, 
// theme = 'DARK_WITHOUT_WORLD_MAP',
showRoomDetailsPopup, showPOI = true, isSimulated = false, }) => {
    var _a, _b, _c, _d, _e;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { mapjs } = useMap();
    // const { id: floorLocationId } = location.state || floorId;
    let floorLocationId = useSelector(getSelectedLocation);
    const locationData = useSelector(getLocation);
    if (!floorLocationId) {
        // If no id present, we are in building view. Just take the first id in children to get the map loaded
        floorLocationId = ((_a = locationData === null || locationData === void 0 ? void 0 : locationData.children[0]) === null || _a === void 0 ? void 0 : _a.id) || '';
    }
    const floorLocationData = locationData === null || locationData === void 0 ? void 0 : locationData.children.find((child) => child.id === floorLocationId);
    const currentFloorNumber = Number(floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.floorNumber);
    const { deviceLocationId } = useSelector(getContext);
    let contextInfo = useSelector(getContext);
    const isInteractive = (_b = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.interactive) !== null && _b !== void 0 ? _b : true;
    const isBuildingViewType = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) === 'building';
    const theme = ((_d = (_c = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.appConfig) === null || _c === void 0 ? void 0 : _c.floor) === null || _d === void 0 ? void 0 : _d.theme) || 'DARK_WITHOUT_WORLD_MAP';
    let shouldShowWhereAmI = 'isWhereAmIEnabled' in contextInfo && contextInfo.isWhereAmIEnabled !== null
        ? contextInfo.isWhereAmIEnabled
        : deviceLocationId !== null;
    if (!isBuildingViewType && deviceLocationId !== floorLocationId) {
        shouldShowWhereAmI = false;
    }
    const isSignageinTheBuilding = (_e = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _e === void 0 ? void 0 : _e.find((child) => child.id === deviceLocationId);
    const [mapInit, setMapInit] = useState(null);
    const [showSearchButton, setShowSearchButton] = useState(true);
    const [showFindMeButton, setShowFindMeButton] = useState(shouldShowWhereAmI && isSignageinTheBuilding);
    const [showResetButton, setShowResetButton] = useState(true);
    // const [deskStatus] = useState<any>(null); //setDeskStatus
    const deskHelperObj = useRef(new DeskHelper()).current;
    const [showRoomSearchPopup, setShowRoomSearchPopup] = useState(false);
    const [showWhereAmISwitchFloor, setShowWhereAmISwitchFloor] = useState(false);
    const listenerCleanupRef = useRef([]);
    const roomHighlightTimeoutRef = useRef(null);
    const deskHighlightTimeoutRef = useRef(null);
    const previousRoomAvailabilityRef = useRef({});
    const previousDeskStatusRef = useRef({});
    const clearScheduledHighlights = () => {
        if (roomHighlightTimeoutRef.current !== null) {
            window.clearTimeout(roomHighlightTimeoutRef.current);
            roomHighlightTimeoutRef.current = null;
        }
        if (deskHighlightTimeoutRef.current !== null) {
            window.clearTimeout(deskHighlightTimeoutRef.current);
            deskHighlightTimeoutRef.current = null;
        }
    };
    const cleanupRichMapListeners = () => {
        listenerCleanupRef.current.forEach((cleanup) => cleanup());
        listenerCleanupRef.current = [];
    };
    const addRichMapListener = (eventName, handler) => {
        var _a, _b, _c;
        const richMap = window.rMap;
        if (!(richMap === null || richMap === void 0 ? void 0 : richMap.listen))
            return;
        const listenResult = richMap.listen(eventName, handler);
        if (typeof listenResult === 'function') {
            listenerCleanupRef.current.push(() => {
                try {
                    listenResult();
                }
                catch (err) {
                    console.warn(`Failed to cleanup Rich Map listener for ${eventName}`, err);
                }
            });
            return;
        }
        const off = ((_a = richMap.off) === null || _a === void 0 ? void 0 : _a.bind(richMap)) ||
            ((_b = richMap.unlisten) === null || _b === void 0 ? void 0 : _b.bind(richMap)) ||
            ((_c = richMap.removeListener) === null || _c === void 0 ? void 0 : _c.bind(richMap));
        if (off) {
            listenerCleanupRef.current.push(() => {
                try {
                    off(eventName, handler);
                }
                catch (err) {
                    console.warn(`Failed to cleanup Rich Map listener for ${eventName}`, err);
                }
            });
        }
    };
    const getAvailabilitySignature = (availabilityMap) => Object.entries(availabilityMap || {})
        .map(([key, value]) => { var _a; return `${key}:${(_a = value === null || value === void 0 ? void 0 : value.availability) !== null && _a !== void 0 ? _a : ''}`; })
        .sort()
        .join('|');
    const applyFeatureHighlightChanges = (previousMap, nextMap) => {
        var _a;
        if (!((_a = window.rMap) === null || _a === void 0 ? void 0 : _a.changeFeatureState))
            return;
        const changedIds = new Set([
            ...Object.keys(previousMap || {}),
            ...Object.keys(nextMap || {}),
        ]);
        changedIds.forEach((key) => {
            const previousEntry = previousMap === null || previousMap === void 0 ? void 0 : previousMap[key];
            const nextEntry = nextMap === null || nextMap === void 0 ? void 0 : nextMap[key];
            if ((previousEntry === null || previousEntry === void 0 ? void 0 : previousEntry.availability) === (nextEntry === null || nextEntry === void 0 ? void 0 : nextEntry.availability) &&
                (previousEntry === null || previousEntry === void 0 ? void 0 : previousEntry.richMapId) === (nextEntry === null || nextEntry === void 0 ? void 0 : nextEntry.richMapId)) {
                return;
            }
            const richMapId = (nextEntry === null || nextEntry === void 0 ? void 0 : nextEntry.richMapId) || (previousEntry === null || previousEntry === void 0 ? void 0 : previousEntry.richMapId) || '';
            const availability = (nextEntry === null || nextEntry === void 0 ? void 0 : nextEntry.availability) || 'Unknown';
            if (!richMapId)
                return;
            try {
                window.rMap.changeFeatureState({
                    source: 'selected-floor',
                    id: richMapId,
                }, FeatureStates[availability.toUpperCase()]);
            }
            catch (e) {
                console.log('to highlight rooms, map is not ready Yet!!!');
            }
        });
    };
    const scheduleRoomHighlight = (nextRoomAvailability = {}) => {
        if (roomHighlightTimeoutRef.current !== null) {
            window.clearTimeout(roomHighlightTimeoutRef.current);
        }
        roomHighlightTimeoutRef.current = window.setTimeout(() => {
            applyFeatureHighlightChanges(previousRoomAvailabilityRef.current, nextRoomAvailability);
            previousRoomAvailabilityRef.current = nextRoomAvailability;
            roomHighlightTimeoutRef.current = null;
        }, 500);
    };
    const scheduleDeskHighlight = (nextDeskStatus = {}) => {
        if (deskHighlightTimeoutRef.current !== null) {
            window.clearTimeout(deskHighlightTimeoutRef.current);
        }
        deskHighlightTimeoutRef.current = window.setTimeout(() => {
            applyFeatureHighlightChanges(previousDeskStatusRef.current, nextDeskStatus);
            previousDeskStatusRef.current = nextDeskStatus;
            deskHighlightTimeoutRef.current = null;
        }, 500);
    };
    const resetHighlightState = () => {
        previousRoomAvailabilityRef.current = {};
        previousDeskStatusRef.current = {};
    };
    useEffect(() => {
        if (mapjs) {
            console.log('Loaded Rich Map JS script; mapInit', mapInit, ' mapDetails:', mapDetails);
            const preferDefaultSettings = (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.showDefaultView) === true ||
                ((contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.pitch) == null &&
                    (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.bearing) == null &&
                    (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.zoom) == null);
            const newMapInit = Object.assign(Object.assign({ mapContainer: 'map-v2', token: richMapAccessToken === null || richMapAccessToken === void 0 ? void 0 : richMapAccessToken.accessToken, tenantId: mapDetails.map.tenantId, locationId: mapDetails.map.buildingId, initialZoom: mapDetails.map.zoom, initialPos: [mapDetails.map.long, mapDetails.map.lat], initialPitch: mapDetails.map.pitch, initialBearing: mapDetails.map.bearing, defaultFloor: mapDetails.map.floorNumber, poiLegendHolder: 'poi-switch', hideNavigationControls: true, disableMapboxAttribution: true, 
                // theme: (window as any).rMap.Themes[theme],
                theme: THEMES[theme], useTiles: false }, richMapAccessToken), { preferDefaultSettings });
            setMapInit(newMapInit);
            resetHighlightState();
            initializeRichMap(newMapInit);
            adjustMapboxControlPosition();
            showButtons();
            cleanupRichMapListeners();
            const poiSwitchElement = document.getElementById('poi-switch');
            if (poiSwitchElement)
                poiSwitchElement.style.position = 'fixed';
            const onLoad = () => {
                var _a, _b, _c;
                console.log('Rich Maps ON_LOAD Event...');
                setTimeout(() => {
                    store.dispatch(setRichMapLoading({ payload: true }));
                }, 1000);
                const val = window.rMap.doRoomHighlight;
                console.log('doRoomHighlight :: ', val);
                //checkIfFloorChangeRequired();
                // checkIfModelRequired();
                window.rMap.loaded = true;
                resetHighlightState();
                // if ((window as any).rMap.doRoomHighlight) {
                // console.log('... map is ready now, going to highlight rooms!');
                scheduleRoomHighlight(mapStatus.roomAvailability);
                // }
                // if ((window as any).rMap.doDeskHighlight) {
                // console.log('... map is ready now, going to highlight desks!');
                scheduleDeskHighlight(mapStatus.deskStatus);
                // }
                const features = window.rMap.getFeatures();
                const POIs = {};
                const allRooms = [];
                const allDesks = [];
                const POISNameMap = {};
                for (const type of POI_TYPES) {
                    POIs[type] = [];
                }
                for (const feature of features) {
                    // fid is undefined for most features, hence going to obtain it from the poid itself by splitting
                    POISNameMap[feature.id.includes('~')
                        ? feature.id.slice(feature.id.indexOf('~') + 1)
                        : feature.id] = {
                        name: (_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.name,
                        sType: (_b = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _b === void 0 ? void 0 : _b.sType,
                        poiId: (_c = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _c === void 0 ? void 0 : _c.fid,
                    };
                    if (feature.properties.type === 'meeting-space' ||
                        feature.properties.type === 'work-space') {
                        const featureObj = {
                            name: feature.id.split('~')[1],
                            floorNumber: Number(feature.properties.lvl),
                            availability: 'Unknown',
                            key: feature.id,
                            capacity: 'Unknown',
                        };
                        if (feature.properties.type === 'meeting-space')
                            allRooms.push(featureObj);
                        if (feature.properties.type === 'work-space')
                            allDesks.push(featureObj);
                    }
                    if (feature.isPOI) {
                        if (feature.properties.type === 'toilets') {
                            POIs['Rest Rooms'].push(feature);
                        }
                        else if (feature.properties.type === 'restaurant') {
                            POIs['Cafeteria'].push(feature);
                        }
                        else if (feature.properties.type === 'help-desk') {
                            POIs['Help Desk'].push(feature);
                        }
                        else if (feature.properties.type === 'child-care') {
                            POIs['Child Care Area'].push(feature);
                        }
                        else if (feature.properties.type === 'stairs') {
                            POIs['Stairs'].push(feature);
                        }
                        else if (feature.properties.type === 'lift') {
                            POIs['Elevators'].push(feature);
                        }
                    }
                }
                store.dispatch(setDeskDataFromMap({ payload: allDesks }));
                store.dispatch(setRoomDataFromMap({ payload: allRooms }));
                store.dispatch(setPOIDataFromMap({
                    payload: { POIs, POISNameMap },
                }));
                // Position 3D model
                checkIfModelRequired();
            };
            const onClick = (e) => {
                console.log('Rich Maps ON_CLICK Event...', e);
                if (!isInteractive) {
                    return;
                }
                const featuresNew = window.rMap.getFeaturesAtPoint(e, [
                    POITypes.MEETING_SPACES,
                    POITypes.WORK_SPACES,
                ]);
                // console.log('featuresNew', featuresNew)
                featuresNew.forEach((el) => {
                    //console.log('featureNew', el);
                    const spacesId = el !== undefined ? el.feature.id : null;
                    if (spacesId) {
                        const clickedRoom = mapStatus.roomAvailability[spacesId];
                        sendTrackingEventForMapClick(spacesId, contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.tenantId);
                        //Center focus richMap location
                        focusRichMapLocation(spacesId);
                        showRoomDetailsPopup(spacesId, clickedRoom === null || clickedRoom === void 0 ? void 0 : clickedRoom.location, clickedRoom === null || clickedRoom === void 0 ? void 0 : clickedRoom.floorNumber);
                    }
                });
                // (window as any).rMap?.current?.map?.on('zoomend', () => {
                //   sendTrackingEventForZoomChange(
                //     (window as any).rMap?.current?.map?.getZoom()?.toFixed(1),
                //     contextInfo?.tenantId
                //   );
                // });
            };
            const onNavigationDataLoad = (navData) => {
                store.dispatch(setDirections({ payload: navData.directions }));
                console.log(`Received : RichMapEvent.NAVIGATION_DATA_LOAD with directions : ${JSON.stringify(navData.directions, null, 2)}`);
            };
            addRichMapListener(RichMapEvent.ON_LOAD, onLoad);
            addRichMapListener(RichMapEvent.ON_CLICK, onClick);
            addRichMapListener(RichMapEvent.NAVIGATION_DATA_LOAD, onNavigationDataLoad);
        }
        return () => {
            cleanupRichMapListeners();
            clearScheduledHighlights();
            resetHighlightState();
            destroyRichMap();
        };
    }, [mapjs]);
    const mapStatus = useRef({
        loaded: false,
        doRoomHighlight: false,
        doDeskHighlight: false,
        roomAvailability: {},
        deskStatus: {},
        markCurrentPosition: false,
    }).current;
    useEffect(() => {
        if (mapStatus.roomAvailability) {
            scheduleRoomHighlight(mapStatus.roomAvailability);
            scheduleDeskHighlight(mapStatus.deskStatus);
            return () => {
                clearScheduledHighlights();
            };
        }
    }, []);
    const checkIfModelReqFlag = useSelector(getCheckIfModelReqFlag);
    useEffect(() => {
        checkIfModelRequired();
    }, [checkIfModelReqFlag]);
    useEffect(() => {
        if (getAvailabilitySignature(previousRoomAvailabilityRef.current) ===
            getAvailabilitySignature(roomAvailability)) {
            return;
        }
        mapStatus.roomAvailability = roomAvailability || {};
        mapStatus.deskStatus = deskStatus || {};
        mapStatus.doRoomHighlight = true;
        scheduleRoomHighlight(mapStatus.roomAvailability);
        scheduleDeskHighlight(mapStatus.deskStatus);
        return () => {
            clearScheduledHighlights();
        };
    }, [roomAvailability]);
    useEffect(() => {
        if (getAvailabilitySignature(previousDeskStatusRef.current) ===
            getAvailabilitySignature(deskStatus)) {
            return;
        }
        mapStatus.deskStatus = deskStatus || {};
        mapStatus.doDeskHighlight = true;
        scheduleDeskHighlight(mapStatus.deskStatus);
        return () => clearScheduledHighlights();
    }, [deskStatus]);
    useEffect(() => {
        checkIfFloorChangeRequired();
    }, [mapDetails.map.floorNumber]);
    function checkIfModelRequired() {
        if (!window.rMap)
            return;
        if (window.rMap.loaded) {
            if (mapDetails.device.modelWithScreen &&
                mapDetails.map.floorLocation === mapDetails.device.deviceLocation &&
                shouldShowWhereAmI) {
                console.log('Going to position 3D Model');
                mapStatus.markCurrentPosition = true;
                const modelPosition = [mapDetails.device.long, mapDetails.device.lat];
                const modelRotationAngle = [
                    mapDetails.device.xAngle,
                    mapDetails.device.yAngle,
                    mapDetails.device.zAngle,
                ];
                window.rMap.markCurrentPosition(modelPosition, modelRotationAngle);
            }
            // Clear camera position and currrent position if floor does not have device location
            if (!mapDetails.device.modelWithScreen ||
                mapDetails.map.floorLocation !== mapDetails.device.deviceLocation) {
                window.rMap.removeCurrentPosition();
                deskHelperObj.removeCameraPosition();
                mapStatus.markCurrentPosition = false;
            }
        }
    }
    // If floor changes we have to call change floor on map
    function checkIfFloorChangeRequired() {
        if (!window.rMap)
            return;
        if (window.rMap
        // &&
        // floorLocationPrev !== mapDetails.map.floorNumber
        ) {
            console.log('Changing floor to ', mapDetails.map.floorNumber);
            window.rMap.changeFloor(mapDetails.map.floorNumber, true);
            console.log('mapDetails Updated', JSON.stringify(mapDetails), 'Selected Floor', mapDetails.map.floorNumber);
            window.rMap.reset();
            checkIfModelRequired();
        }
        // Focus room if we selected from previous floor search box
        const otherFloorRoom = mapDetails.map.otherFloorRoom;
        if (otherFloorRoom) {
            focusRichMapLocation(otherFloorRoom.richMapId);
            if (showRoomDetailsPopup && isInteractive) {
                showRoomDetailsPopup(otherFloorRoom.richMapId, otherFloorRoom === null || otherFloorRoom === void 0 ? void 0 : otherFloorRoom.location, otherFloorRoom === null || otherFloorRoom === void 0 ? void 0 : otherFloorRoom.floorNumber);
            }
        }
    }
    function focusRichMapLocation(richMapId) {
        if (!window.rMap)
            return;
        if (richMapId) {
            window.rMap.focusFeature(richMapId);
        }
    }
    const showButtons = () => {
        console.log('Buttons showing up, isInteractive:', isInteractive);
        isInteractive && setShowSearchButton(true);
        // isInteractive && setShowFindMeButton(true);
        isInteractive && setShowResetButton(true);
    };
    const handleSearchButtonClick = () => {
        console.log('Search Button clicked');
        // Add your logic here
        // setShowRoomSearchPopup(true);
        store.dispatch(setRoomSearchPopUp({ payload: true }));
    };
    const handleFindMeButtonClick = () => {
        console.log('FindMe button clicked');
        if (mapDetails.map.floorLocation !== mapDetails.device.deviceLocation) {
            //Non where am I floor case
            setShowWhereAmISwitchFloor(true);
        }
        else {
            // Where am I floor case
            window.rMap.locate();
        }
    };
    const handleResetButtonClick = () => {
        console.log('ResetButton clicked');
        window.rMap.reset();
        window.rMap.exitNavigation();
        closeRoomDetailsPopup();
        // closeRoomDetailsPopup();
    };
    const isRichMapLoaded = useSelector(getRichMapLoaded);
    return (_jsxs("div", { children: [showWhereAmISwitchFloor && (_jsx(WhereAmISwitchFloor, { currentFloorNumber: currentFloorNumber, switchFloorNumber: Number(mapDetails.device.deviceLocation), selectFloor: (id) => {
                    closeRoomDetailsPopup();
                    // navigate('/floor', { state: { id } });
                    dispatch(setSelectedLocation(id));
                    setShowWhereAmISwitchFloor(false);
                    setTimeout(() => {
                        window.rMap.locate();
                    }, 1000);
                }, onClose: () => {
                    setShowWhereAmISwitchFloor(false);
                } })), isInteractive && (_jsxs(FloorMapButton, { children: [showSearchButton && (_jsxs(Button, Object.assign({ id: "search_button", onClick: window.rMap &&
                            window.rMap.loaded &&
                            handleSearchButtonClick }, { children: [_jsx(ButtonIcon, Object.assign({ style: { transform: 'scale(1.2)' } }, { children: _jsx(Search, {}) })), _jsx(ButtonLabel, { children: t('floor.search') })] }))), showFindMeButton && (_jsxs(WhereAmIButton, Object.assign({ id: "where_am_i_button", onClick: handleFindMeButtonClick }, { children: [_jsx(WhereAmIIcon, { src: require('../../../../../assets/images/spot-mascot.png'), alt: "Where am I" }), _jsx(WhereAmILabel, { children: t('floor.where-am-I') })] }))), showResetButton && (_jsxs(Button, Object.assign({ id: "recenter_map_button", onClick: handleResetButtonClick }, { children: [_jsx(ButtonIcon, { children: _jsx(MapCompass, {}) }), _jsx(ButtonLabel, { children: t('floor.re-center-map') })] }))), !showResetButton && (_jsx("div", { children: _jsx("img", { src: "static/images/reset-floor-map-disabled.svg", alt: "Reset Disabled" }) }))] })), isInteractive && showPOI && !isSimulated && window.rMap && (_jsxs("div", Object.assign({ id: "poi-switch", style: {
                    bottom: `7.8vw`,
                    right: `1.0vw`,
                    paddingBottom: '0.4vw',
                    zIndex: '1',
                    position: 'fixed',
                    opacity: '1',
                    width: 'fit-content',
                } }, { children: [_jsx("p", Object.assign({ id: "wordStyle1" }, { children: t('floor.map.label-poi-on-this-floor') })), _jsx("p", Object.assign({ id: "wordStyle", style: { margin: '1vw 1.4vw' } }, { children: [t('floor.map.label-poi-select-to-find-on-map'), ':'] }))] })))] }));
};
export default MapComponent;
